function toggleDescription(btnText, truncateText, moreText) {
  if (moreText.classList.contains("show")) {
    moreText.style.maxHeight = "0";
    moreText.style.opacity = "0";
    moreText.classList.remove("show");
    btnText.innerHTML = "Read more";
    moreText.style.display = "none";
    truncateText.style.display = "block";
    truncateText.style.opacity = "1";
  } else {
    truncateText.style.opacity = "0";
    truncateText.style.display = "none";
    moreText.style.display = "block";
    const autoHeight = moreText.scrollHeight + "px";
    moreText.style.maxHeight = autoHeight;
    moreText.style.opacity = "1";
    moreText.classList.add("show");
    btnText.innerHTML = "Read less";
  }
}

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (event) {
    event.preventDefault;
    if (event.target && event.target.id === "myBtn" || event.target.id === "myBtnMobile") {
      const btnText = event.target;
      const wrapper = btnText.closest(".hc-collection-description");
      const truncateText = wrapper.querySelector(".hc-collection-description__truncate");
      const moreText = wrapper.querySelector(".hc-collection-description__original");

      toggleDescription(btnText, truncateText, moreText);
    }
  });
});